import { render } from "./ExpressDelivery.vue?vue&type=template&id=90cbcfe2&scoped=true"
import script from "./ExpressDelivery.vue?vue&type=script&lang=js"
export * from "./ExpressDelivery.vue?vue&type=script&lang=js"

import "./ExpressDelivery.vue?vue&type=style&index=0&id=90cbcfe2&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90cbcfe2"]])

export default __exports__